// App Constants - Calculated once at build time
export const APP_VERSION = 'v1.0.19'; // Base team engineer feedback: version:"next" in embed metadata
export const BUILD_TIME = '07/29/2025, 01:55:24 HKT'; // Static timestamp - updated on each deployment // Static timestamp - updated on each deployment // Static timestamp - updated on each deployment

export const APP_NAME = 'Alpha Pie';
export const APP_TAGLINE = 'How many Pie can you cook?';

// Debug configuration - check if in development environment
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

// TBA (The Base App) specific constants
export const TBA_CLIENT_FID = 309857; // TBA's official clientFid
export const TBA_SUPPORTED_ACTIONS = [
  'openUrl',
  'close',
  'ready',
  // Note: TBA doesn't support haptic feedback, token actions, or Warpcast deeplinks yet
];

// Client detection utilities
export const detectClient = (context) => {
  if (!context?.client) return 'unknown';
  
  // TBA detection
  if (context.client.clientFid === TBA_CLIENT_FID) {
    return 'tba'; // The Base App
  }
  
  // Warpcast detection
  if (context.client.name?.toLowerCase().includes('warpcast')) {
    return 'warpcast';
  }
  
  return context.client.name || 'unknown';
}; 